import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section id="chi-siamo" className="py-5 bg-white">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary mb-3 fw-semibold">CHI SIAMO</span>
            <h2 className="display-6 fw-bold mb-4">Una casa editrice che coltiva storie autentiche</h2>
            
            <p className="lead mb-4">
              Bookolica nasce dalla passione per i libri che cambiano prospettive e aprono nuovi mondi.
            </p>
            
            <div className="mb-4">
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-book-half fs-4 text-primary me-3"></i>
                  <h5 className="fw-bold m-0">Storie che ispirano</h5>
                </div>
                <p className="ps-5 mb-0">
                  Pubblichiamo libri che coltivano la mente e nutrono l'anima, scelti con cura per il loro valore culturale e umano.
                </p>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-people fs-4 text-primary me-3"></i>
                  <h5 className="fw-bold m-0">Comunità di lettori</h5>
                </div>
                <p className="ps-5 mb-0">
                  Creiamo collegamenti tra autori e lettori, favorendo eventi, incontri e occasioni di scambio culturale.
                </p>
              </div>
              
              <div>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-tree fs-4 text-primary me-3"></i>
                  <h5 className="fw-bold m-0">Sostenibilità e cultura</h5>
                </div>
                <p className="ps-5 mb-0">
                  Utilizziamo carta certificata e processi ecosostenibili, perché crediamo che i libri debbano rispettare l'ambiente tanto quanto nutrono la mente.
                </p>
              </div>
            </div>
            
            <div className="mt-4">
              <a href="mailto:info@bookolica.space" className="btn btn-primary">
                Contattaci
              </a>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="position-relative">
              <div className="rounded shadow ratio ratio-4x3 overflow-hidden bg-light">
                <div className="d-flex flex-column justify-content-center align-items-center text-center p-4 bg-light">
                  <div className="mb-3">
                    <i className="bi bi-book text-primary" style={{fontSize: '4rem'}}></i>
                  </div>
                  <div className="mb-3">
                    <i className="bi bi-tree-fill text-success" style={{fontSize: '3.5rem'}}></i>
                  </div>
                  <h4 className="fw-bold text-muted">La nostra filosofia:</h4>
                  <p className="fs-5 text-primary fw-semibold">
                    "Coltiviamo storie che mettono radici nell'anima del lettore"
                  </p>
                </div>
              </div>
              
              <div className="position-absolute top-0 start-0 translate-middle">
                <div className="rounded-circle bg-success p-3 shadow">
                  <i className="bi bi-journal-text text-white fs-4"></i>
                </div>
              </div>
              
              <div className="position-absolute bottom-0 end-0 translate-middle">
                <div className="rounded-circle bg-primary p-3 shadow">
                  <i className="bi bi-pencil-fill text-white fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 